// umlaut-check: skip — Datenschluessel ("saisonfaktoren", "saison_gepflegt")
// sind technische Bezeichner aus cosmos_artikel_kennzahlen/-parameter.

import React, {useMemo} from "react";
import {Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import ChartCard from "../Statistics/ChartCard.jsx";
import {formatFaktor} from "./format.js";

const MONATE = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
const FARBE_GEMESSEN = "#0d6efd";
const FARBE_GEPFLEGT = "#fd7e14";

/**
 * Saisonfaktoren, gemessen neben gepflegt (PLAN.md Abschnitt 4.2, Thorstens
 * Wunsch: "ob im Winter mehr oder weniger verkauft wird"). Der Vorbehalt
 * (Vergangenheit teils durch Lieferunfähigkeit verzerrt) steht sichtbar
 * dabei, solange cosmos_artikel_kennzahlen.saison_vorbehalt gesetzt ist.
 */
export default function ArtikelSaisonChart({kennzahl, artikel, hoehe = 220}) {
    const zeilen = useMemo(() => {
        const gemessen = kennzahl?.saisonfaktoren || {};
        const gepflegt = artikel?.saison_gepflegt || null;

        return MONATE.map((label, index) => {
            const monat = index + 1;
            return {
                monat,
                label,
                gemessen: gemessen[monat] ?? gemessen[String(monat)] ?? null,
                gepflegt: gepflegt ? (gepflegt[monat] ?? gepflegt[String(monat)] ?? null) : null,
            };
        });
    }, [kennzahl, artikel]);

    const hatDaten = zeilen.some((z) => z.gemessen !== null || z.gepflegt !== null);

    return (
        <ChartCard
            title="Saisonfaktoren"
            help="Je Kalendermonat ein eigener Faktor (1,0 = Durchschnitt), gemessen aus den letzten Jahren neben dem gepflegten Wert. Vorsicht: die gemessenen Faktoren stammen bislang aus fakturierter Menge und können durch Lieferunfähigkeit verzerrt sein."
            empty={!hatDaten}
            height={hoehe + 20}
        >
            {kennzahl?.saison_vorbehalt && (
                <div className="alert alert-light border small py-1 px-2 mb-2">
                    Vorbehalt: aus fakturierter Menge gemessen, durch Lieferunfähigkeit verzerrt – wird gegen die
                    bestellte Menge nachgeschärft, sobald genug Daten vorliegen ({kennzahl.saison_jahre ?? 0} Jahre
                    verwendet).
                </div>
            )}
            <ResponsiveContainer width="100%" height={hoehe}>
                <BarChart data={zeilen} margin={{top: 8, right: 12, left: 0, bottom: 0}}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e9ecef" />
                    <XAxis dataKey="label" tick={{fontSize: 12}} axisLine={false} tickLine={false} />
                    <YAxis domain={[0, "auto"]} tick={{fontSize: 12}} axisLine={false} tickLine={false} width={40} tickFormatter={(v) => formatFaktor(v)} />
                    {/* Befund Sichtprüfung 3 #S10: Recharts trennt Name/Wert per
                        Vorgabe mit " : " (Leerzeichen vor dem Doppelpunkt) - hier
                        auf ": " (Leerzeichen nur danach) gestellt. */}
                    <Tooltip formatter={(value, name) => [formatFaktor(value), name]} separator=": " />
                    <Bar dataKey="gemessen" name="Gemessen" fill={FARBE_GEMESSEN} radius={[3, 3, 0, 0]} barSize={12} isAnimationActive={false} />
                    <Bar dataKey="gepflegt" name="Gepflegt" fill={FARBE_GEPFLEGT} radius={[3, 3, 0, 0]} barSize={12} isAnimationActive={false} />
                </BarChart>
            </ResponsiveContainer>
        </ChartCard>
    );
}
